import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

// Try to load logo, fallback to text if not found
const getLogo = () => {
  try {
    return require('../assets/images/logo/logo.png');
  } catch (err) {
    return null;
  }
};

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [logo, setLogo] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setLogo(getLogo());
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Products', path: '/products' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'About', path: '/about' },
    { name: 'Career', path: '/career' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      {/* Premium Background Effects */}
      <div className="header-bg-effects">
        <div className="header-glow"></div>
        <div className="header-particles">
          {[...Array(8)].map((_, i) => (
            <div key={i} className={`header-particle particle-${i + 1}`}></div>
          ))}
        </div>
      </div>

      <div className="header-container">
        {/* Premium Logo with Animation */}
        <Link to="/" className="logo">
          <div className="logo-wrapper">

            {logo ? (
              <img src={logo} alt="Anviom" className="logo-image" />
            ) : (
              <div className="logo-text-wrapper">
                <span className="logo-text">ANVIOM</span>
              </div>
            )}
            <span className="brand-mobile">Anviom</span>
          </div>
        </Link>

        {/* Premium Navigation */}
        <nav className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <div className="nav-menu-bg"></div>
          {navLinks.map((link, index) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              style={{ '--link-index': index }}
            >
              <span className="nav-link-bg"></span>
              <span className="nav-link-text">{link.name}</span>
              <span className="nav-link-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </Link>
          ))}
        </nav>

        {/* Premium Actions */}
        <div className="header-actions">
          {/* <div className="theme-toggle-wrapper">
            <ThemeToggle />
          </div> */}
          <a href="tel:+919900257351" className="phone-button">
            <span className="phone-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            <span className="phone-text">+91 9900257351</span>
          </a>
          <Link to="/contact" className="cta-button-nav">
            <span className="cta-text">Get Started</span>
            <span className="cta-arrow">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Link>
        </div>

        {/* Premium Mobile Menu Toggle */}
        <button
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span className="toggle-line"></span>
          <span className="toggle-line"></span>
          <span className="toggle-line"></span>
          <span className="toggle-circle"></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
